import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const RightAsideLoading = () => (
    <Flex
        width="100%"
        height="100%"
        alignItems="center"
        justifyContent="center"
    >
        <Stack
            alignItems="stretch"
            justifyContent="start"
            gap="8px"
        >
            <PixelPlaceholderLoader
                height={92}
                width="100%"
            />
            <PixelPlaceholderLoader
                height={92}
                width="100%"
            />
        </Stack>
    </Flex>
);

